import type { DriverListQuery, EmploymentStatus } from '@chukua/common';
import { EMPLOYMENT_STATUSES } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import { COMPLIANCE_LABELS } from '../../components/document-status-labels';
import type { ListQueryControls } from '../../lib/use-list-query';
import { driverPath } from './driver-tabs';
import type { DriverListItem } from './drivers.api';
import { EMPLOYMENT_STATUS_COLORS, EMPLOYMENT_STATUS_LABELS } from './employment-status-labels';

interface BuildDriverColumnsArgs {
  list: Pick<ListQueryControls<DriverListQuery>, 'sortOrderFor' | 'filteredValueFor'>;
}

const STATUS_FILTERS = EMPLOYMENT_STATUSES.map((status) => ({ text: EMPLOYMENT_STATUS_LABELS[status], value: status }));

/** Sorting and filtering run on the server: each column's `key` is its `sort` field or filter param in `driverListQuerySchema`. */
export function buildDriverColumns({ list }: BuildDriverColumnsArgs): TableColumnsType<DriverListItem> {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (name: string, driver) => (
        <Link className="font-medium text-link hover:underline" to={driverPath(driver.id)}>
          {name}
        </Link>
      ),
    },
    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    { title: 'Licence number', dataIndex: 'licenceNumber', key: 'licenceNumber' },
    {
      title: 'Status',
      key: 'status',
      filters: STATUS_FILTERS,
      filteredValue: list.filteredValueFor('status'),
      render: (_, driver) => (
        <Tag color={EMPLOYMENT_STATUS_COLORS[driver.employmentStatus as EmploymentStatus]}>
          {EMPLOYMENT_STATUS_LABELS[driver.employmentStatus as EmploymentStatus]}
        </Tag>
      ),
    },
    {
      title: 'Compliance',
      key: 'compliance',
      render: (_, driver) => <Tag color={COMPLIANCE_LABELS[driver.compliance].color}>{COMPLIANCE_LABELS[driver.compliance].label}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, driver) => (
        <Link className="text-sm font-medium text-link hover:underline" to={driverPath(driver.id)}>
          View
        </Link>
      ),
    },
  ];
}
